import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReportRoutingModule } from './report-routing.module';
import { GlobalModulesModule } from 'src/app/core/global-modules/global-modules.module';
import { ReportViewerComponent } from './report-viewer/report-viewer.component';
import { PaginatorComponent } from './paginator/paginator.component';
import { FormatNumberPipe } from './format-number-pipe/format-number.pipe';

@NgModule({
  imports: [CommonModule, GlobalModulesModule, ReportRoutingModule],
  declarations: [ReportViewerComponent, PaginatorComponent, FormatNumberPipe],
  exports: [ReportViewerComponent, PaginatorComponent]
})
export class ReportModule {}
